var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrench = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "svg-wrench__a",
  d: "m13.843.036-.04.002A4.96 4.96 0 0 0 9.27 5.094l.006.248c.013.248.052.498.116.744l.041.14-7.576 6.68a3.22 3.22 0 0 0-.352 4.438l.144.163a3.12 3.12 0 0 0 2.39.973l.205-.016a3.11 3.11 0 0 0 2.083-1.135l6.71-7.547.305.064c.62.11 1.256.121 1.882.029a5.03 5.03 0 0 0 3.833-3.52 5.19 5.19 0 0 0-.086-2.888l-.251-.776-2.673 2.66L13.9 3.212l2.695-2.68-.82-.233a6.886 6.886 0 0 0-1.932-.263Zm.023 1 .318.007c.112.005.223.014.334.026l.106.013-2.14 2.133 3.563 3.547 2.148-2.14.017.176c.027.432-.013.869-.121 1.293a4.015 4.015 0 0 1-3.042 2.8 4.834 4.834 0 0 1-2.041-.15l-.304-.088-7.14 8.03a2.11 2.11 0 0 1-3.18.149l-.117-.135a2.218 2.218 0 0 1 .253-3.044l8.09-7.131-.132-.329a2.849 2.849 0 0 1-.209-1.105 3.966 3.966 0 0 1 3.42-4.032l.177-.02Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "matrix(-1 0 0 1 22 3)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "svg-wrench__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-wrench__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#svg-wrench__a",
  fill: "#7F7F7F",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-wrench__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M-2-3h24v24H-2z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrench);
export default ForwardRef;